var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRefreshdark(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.6795 10.0435C15.3007 10.0435 15 9.72656 15 9.34783C15 6.85273 14.4009 5.35239 13.556 4.47077C12.7264 3.60503 11.3362 3 9 3C6.66381 3 5.27364 3.60503 4.44398 4.47077C4.11097 4.81825 3.81615 5.26185 3.58115 5.82458C3.40279 6.25167 3.00688 6.56522 2.54405 6.56522C1.88828 6.56522 1.39437 5.95565 1.62228 5.34076C2.69489 2.44692 5.15413 1 9 1C14.3333 1 17 3.78261 17 9.34783C17 9.73684 16.6787 10.0435 16.2896 10.0435H15.6795ZM14.9155 10.8651V11.3195C14.9155 11.7674 15.2785 12.1304 15.7264 12.1304C16.243 12.1304 16.6309 12.6093 16.4676 13.0994C15.4466 16.1636 12.9574 17.6957 9 17.6957C3.66667 17.6957 1 14.913 1 9.34783C1 8.95881 1.32134 8.65217 1.71035 8.65217H2.32054C2.69928 8.65217 3 8.96909 3 9.34783C3 11.8429 3.59909 13.3433 4.44398 14.2249C5.27364 15.0906 6.66381 15.6957 9 15.6957C11.3362 15.6957 12.7264 15.0906 13.556 14.2249C14.2135 13.5388 14.7222 12.4779 14.9155 10.8651Z",
    fill: "#5A5D74"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.69572 1.69565V5.86956H5.86963",
    stroke: "#767BFA",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3043 17L16.3043 12.8261L12.1304 12.8261",
    stroke: "#767BFA",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefreshdark);
export default __webpack_public_path__ + "static/media/refreshdark.96e0d0827c561069dbb1a99833b5466f.svg";
export { ForwardRef as ReactComponent };